import { http } from '../utils';
const controller = 'helpdesk/notifications';
export const getNotifications = async (params) => await http.get(controller, {
    params: params
});
export const markNotificationsAsRead = async (notificationId) => await http.put(`${controller}/mark-read?notificationId=${notificationId ?? ''}`);
export const markAllNotificationsAsRead = async () => await http.put(`${controller}/mark-read/all`);
export const markNotificationsAsUnRead = async (notificationId) => await http.put(`${controller}/mark-unread?notificationId=${notificationId ?? ''}`);
export const markAllNotificationsAsUnRead = async () => await http.put(`${controller}/mark-unread/all`);
